import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { getSelectorStyling, getMenuItemStyling } from "../Common/tableFilterStyles";

const QuickTapsFilterHeader = ({ filters, onFilterChange }) => {
  return (
    <TableHead>
      <TableRow sx={{
        backgroundColor: '#f5f5f5',
        '& .MuiTableCell-root': {
          padding: '6px 8px',
          fontSize: '0.8rem'
        }
      }}>
        <TableCell sx={{ fontWeight: 'bold', minWidth: 160, width: '22%' }}>Title</TableCell>
        <TableCell sx={{ fontWeight: 'bold', minWidth: 120, width: '18%' }}>Category/Subcategory</TableCell>
        <TableCell sx={{ fontWeight: 'bold', minWidth: 60, width: '8%' }}>Duration</TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', width: '10%' }}>
          <FormControl size="small" sx={getSelectorStyling(85)}>
            <InputLabel>Is Active</InputLabel>
            <Select
              value={filters.isActive}
              label="Is Active"
              onChange={onFilterChange('isActive')}
              sx={{ fontSize: '0.75rem' }}
            >
              <MenuItem value="all" sx={getMenuItemStyling()}>All</MenuItem>
              <MenuItem value="1" sx={getMenuItemStyling()}>Active</MenuItem>
              <MenuItem value="0" sx={getMenuItemStyling()}>Inactive</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', width: '10%' }}>
          <FormControl size="small" sx={getSelectorStyling(85)}>
            <InputLabel>Featured</InputLabel>
            <Select
              value={filters.featured}
              label="Featured"
              onChange={onFilterChange('featured')}
              sx={{ fontSize: '0.75rem' }}
            >
              <MenuItem value="all" sx={getMenuItemStyling()}>All</MenuItem>
              <MenuItem value="1" sx={getMenuItemStyling()}>Featured</MenuItem>
              <MenuItem value="0" sx={getMenuItemStyling()}>Normal</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', width: '10%' }}>
          <FormControl size="small" sx={getSelectorStyling(85)}>
            <InputLabel>Premium</InputLabel>
            <Select
              value={filters.premium}
              label="Premium"
              onChange={onFilterChange('premium')}
              sx={{ fontSize: '0.75rem' }}
            >
              <MenuItem value="all" sx={getMenuItemStyling()}>All</MenuItem>
              <MenuItem value="1" sx={getMenuItemStyling()}>Premium</MenuItem>
              <MenuItem value="0" sx={getMenuItemStyling()}>Free</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', minWidth: 60, width: '10%' }}>Author</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold', minWidth: 60, width: '12%' }}>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default QuickTapsFilterHeader;
